<template>
  <v-card class="card--shadow">
    <v-card-title class=" purple accent-4">
      <div class="subtitle-1 white--text">
        Township Group Form
      </div>
    </v-card-title>
    <v-card-text class="pt-4">
      <label>Township Group</label>
      <v-text-field
        v-model.trim="townshipGroup.name"
        :error-messages="nameErrors"
        type="text"
        outlined
        dense
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn
        v-if="townshipGroup.id"
        @click.prevent="emitTownshipGroupData"
        class="form-btn"
      >
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitTownshipGroupData" class="form-btn">
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";

export default {
  mixins: [ValidationMixin],
  props: {
    townshipGroup: {
      type: Object,
      default: () => {
        return {
          name: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    townshipGroup: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    nameErrors() {
      return this.handleFieldErrors(this.$v.townshipGroup.name);
    },
  },
  methods: {
    emitTownshipGroupData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.townshipGroup.name,
        };

        this.townshipGroup.id ? (data.id = this.townshipGroup.id) : false;

        this.$emit("emitTownshipGroupData", data);

        this.townshipGroup.name = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
